// extracted by mini-css-extract-plugin
module.exports = {"delete":"styles_delete__3oePp"};